import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class configVignettes_template extends vnTemplate {

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["page-content"];
    }

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form author-setting">
                <div class="form-header">
                    <h3 class="form-title">Vignette Settings</h3>
                </div>
                <div class="form-body">
                    <div class="w-form-body">
                        <div class="form-group row top">
                            <label for="brandName" class="form-label">Brand Name</label>
                            <input class="input-text" type="text" data-bind="value: brandName" id="brandName" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandShortName" class="form-label">Brand Short Name</label>
                            <input class="input-text" type="text" data-bind="value: brandShortName" id="brandShortName" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandColorScheme" class="form-label">Brand Color Scheme</label>
                            <input class="input-text" type="text" data-bind="value: brandColorScheme" id="brandColorScheme" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandPrimaryColor" class="form-label">Brand Primary Color</label>
                            <input class="input-text" type="text" data-bind="value: brandPrimaryColor" id="brandPrimaryColor" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandFont" class="form-label">Brand Font</label>
                            <input class="input-text" type="text" data-bind="value: brandFont" id="brandFont" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandLogoUrl" class="form-label">Brand Logo URL</label>
                            <input class="input-text" type="text" data-bind="value: brandLogoUrl" id="brandLogoUrl" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandLogoUrlDark" class="form-label">Brand Logo URL (Dark)</label>
                            <input class="input-text" type="text" data-bind="value: brandLogoUrlDark" id="brandLogoUrlDark" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandIconUrl" class="form-label">Brand Icon URL</label>
                            <input class="input-text" type="text" data-bind="value: brandIconUrl" id="brandIconUrl" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandIconUrlDark" class="form-label">Brand Icon URL (Dark)</label>
                            <input class="input-text" type="text" data-bind="value: brandIconUrlDark" id="brandIconUrlDark" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandEmakiLogoUrl" class="form-label">Brand Emaki Logo URL</label>
                            <input class="input-text" type="text" data-bind="value: brandEmakiLogoUrl" id="brandEmakiLogoUrl" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandEmakiLogoUrlDark" class="form-label">Brand Emaki Logo URL (Dark)</label>
                            <input class="input-text" type="text" data-bind="value: brandEmakiLogoUrlDark" id="brandEmakiLogoUrlDark" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandEmakiShortlogoUrl" class="form-label">Brand Emaki Short Logo URL</label>
                            <input class="input-text" type="text" data-bind="value: brandEmakiShortlogoUrl" id="brandEmakiShortlogoUrl" />
                        </div>
                        <div class="form-group row top">
                            <label for="brandEmakiShortlogoUrlDark" class="form-label">Brand Emaki Short Logo URL (Dark)</label>
                            <input class="input-text" type="text" data-bind="value: brandEmakiShortlogoUrlDark" id="brandEmakiShortlogoUrlDark" />
                        </div>
                    </div>
                </div>
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "configVignettes_template";
    }

    protected buildViewModel(): any {
        const self = this;

        return {
            brandName: ko.observable(""),
            brandShortName: ko.observable(""),
            brandColorScheme: ko.observable(""),
            brandPrimaryColor: ko.observable(""),
            brandFont: ko.observable(""),
            brandLogoUrl: ko.observable(""),
            brandLogoUrlDark: ko.observable(""),
            brandIconUrl: ko.observable(""),
            brandIconUrlDark: ko.observable(""),
            brandEmakiLogoUrl: ko.observable(""),
            brandEmakiLogoUrlDark: ko.observable(""),
            brandEmakiShortlogoUrl: ko.observable(""),
            brandEmakiShortlogoUrlDark: ko.observable(""),
            onClickSave: function () {
                self.onClickSave();
            },
            onClickCancel: function () {
                self.onClickCancel();
            },
        };
    }

    public setBrandReferences(brandReferences: any): void {
        const refs = brandReferences && typeof brandReferences === "object" ? brandReferences : {};
        const vm = this.getTemplateViewModel();

        vm.brandName(refs.brand_name || "");
        vm.brandShortName(refs.brand_short_name || "");
        vm.brandColorScheme(refs.brand_color_scheme || "");
        vm.brandPrimaryColor(refs.brand_primary_color || "");
        vm.brandFont(refs.brand_font || "");
        vm.brandLogoUrl(refs.brand_logo_url || "");
        vm.brandLogoUrlDark(refs.brand_logo_url_dark || "");
        vm.brandIconUrl(refs.brand_icon_url || refs.brand_shortlogo_url || "");
        vm.brandIconUrlDark(refs.brand_icon_url_dark || refs.brand_shortlogo_url_dark || "");
        vm.brandEmakiLogoUrl(refs.brand_emaki_logo_url || "");
        vm.brandEmakiLogoUrlDark(refs.brand_emaki_logo_url_dark || "");
        vm.brandEmakiShortlogoUrl(refs.brand_emaki_shortlogo_url || "");
        vm.brandEmakiShortlogoUrlDark(refs.brand_emaki_shortlogo_url_dark || "");
    }

    public getVignetteSettings(): any {
        return {
            brand_references: {
                brand_name: this.getTemplateViewModel().brandName(),
                brand_short_name: this.getTemplateViewModel().brandShortName(),
                brand_color_scheme: this.getTemplateViewModel().brandColorScheme(),
                brand_primary_color: this.getTemplateViewModel().brandPrimaryColor(),
                brand_font: this.getTemplateViewModel().brandFont(),
                brand_logo_url: this.getTemplateViewModel().brandLogoUrl(),
                brand_logo_url_dark: this.getTemplateViewModel().brandLogoUrlDark(),
                brand_icon_url: this.getTemplateViewModel().brandIconUrl(),
                brand_icon_url_dark: this.getTemplateViewModel().brandIconUrlDark(),
                brand_emaki_logo_url: this.getTemplateViewModel().brandEmakiLogoUrl(),
                brand_emaki_logo_url_dark: this.getTemplateViewModel().brandEmakiLogoUrlDark(),
                brand_emaki_shortlogo_url: this.getTemplateViewModel().brandEmakiShortlogoUrl(),
                brand_emaki_shortlogo_url_dark: this.getTemplateViewModel().brandEmakiShortlogoUrlDark(),
            },
        };
    }

    protected onClickSave(): void {
        this.caller.saveSettings();
    }

    protected onClickCancel(): void {
        this.caller.cancelSettings();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configVignettes_template.ts